import { Page, View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  Portfolio,
  PublicEventDetailsResponse,
  ResponsePaginationType,
} from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { getImageSrc } from '@utils/fn';

export interface EventSeriesPageProps {
  event: PublicEventDetailsResponse;
  eventSeries: PublicEventDetailsResponse[];
  portfolio: Portfolio | undefined;
  footer: JSX.Element;
}

const EventSeriesPage = ({
  event,
  eventSeries,
  portfolio,
  footer,
}: EventSeriesPageProps) => {
  const { t } = useTranslation();

  if (!event?.colocated) {
    return null;
  }

  const eventSeriesList = eventSeries
    ?.filter(
      (e: PublicEventDetailsResponse) =>
        !e.webinar && !!e.start_date && !!e?.images?.logo
    )
    ?.sort(
      (a, b) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
    )
    ?.slice(0, 12);

  return (
    <Page size={{ width: 1440, height: 800 }} style={{ ...styles.page }}>
      <View
        style={{
          ...styles.pageWrapper,
        }}
      >
        <Text
          style={{
            ...styles.highlightedTitle,
            color: event?.design?.themeColor,
          }}
        >
          {t('event-series')}
        </Text>
        <Text style={styles.title}>{portfolio?.name}</Text>
        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? '#0F91AE',
            marginLeft: 0,
            marginTop: 20,
          }}
        ></View>

        <View style={styles.galleryContainer}>
          {eventSeriesList?.map((eventItem, index) => {
            const logoSrc = getImageSrc(eventItem?.images?.logo);

            return (
              logoSrc && (
                <View
                  key={index}
                  style={{
                    ...styles.logoWrapper,
                  }}
                >
                  <Image style={styles.logoImage} src={logoSrc} />
                </View>
              )
            );
          })}
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default EventSeriesPage;
